// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, UpNextResponse } from 'types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';

// Action types
export const LOAD_UP_NEXT_REQUEST = Symbol('loaders/LOAD_UP_NEXT_REQUEST');
export const LOAD_UP_NEXT_SUCCESS = Symbol('loaders/LOAD_UP_NEXT_SUCCESS');
export const LOAD_UP_NEXT_ERROR = Symbol('loaders/LOAD_UP_NEXT_ERROR');

export const DISMISS_UP_NEXT_REQUEST = Symbol(
  'loaders/DISMISS_UP_NEXT_REQUEST',
);
export const DISMISS_UP_NEXT_SUCCESS = Symbol(
  'loaders/DISMISS_UP_NEXT_SUCCESS',
);
export const DISMISS_UP_NEXT_ERROR = Symbol('loaders/DISMISS_UP_NEXT_ERROR');

export type LoadUpNextRequestAction = Action<typeof LOAD_UP_NEXT_REQUEST, null>;
export type LoadUpNextSuccessAction = Action<
  typeof LOAD_UP_NEXT_SUCCESS,
  UpNextResponse[]
>;
export type LoadUpNextErrorAction = Action<typeof LOAD_UP_NEXT_ERROR, Error>;

export type DismissUpNextRequestAction = Action<
  typeof DISMISS_UP_NEXT_REQUEST,
  null
>;
export type DismissUpNextSuccessAction = Action<
  typeof DISMISS_UP_NEXT_SUCCESS,
  { idUpNext: string }
>;
export type DismissUpNextErrorAction = Action<
  typeof DISMISS_UP_NEXT_ERROR,
  Error
>;

// Action creators
const loadUpNextRequest = actionCreator<LoadUpNextRequestAction>(
  LOAD_UP_NEXT_REQUEST,
);
const loadUpNextSuccess = actionCreator<LoadUpNextSuccessAction>(
  LOAD_UP_NEXT_SUCCESS,
);
const loadUpNextError = actionCreator<LoadUpNextErrorAction>(
  LOAD_UP_NEXT_ERROR,
);

const dismissUpNextRequest = actionCreator<DismissUpNextRequestAction>(
  DISMISS_UP_NEXT_REQUEST,
);
const dismissUpNextSuccess = actionCreator<DismissUpNextSuccessAction>(
  DISMISS_UP_NEXT_SUCCESS,
);
const dismissUpNextError = actionCreator<DismissUpNextErrorAction>(
  DISMISS_UP_NEXT_ERROR,
);

export const loadUpNext = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(loadUpNextRequest());

      const upNext = await API.client.rest.get<UpNextResponse[]>(
        'members/me/upNext',
        {
          query: {
            actions_display: true,
            actions_entities: true,
            actions_memberCreator: true,
            card_board: true,
            card_board_organization: true,
            card_list: true,
            card_members: true,
          },
        },
      );

      dispatch(loadUpNextSuccess(upNext));
    } catch (err) {
      dispatch(loadUpNextError(err));
    }
  };
};

export const dismissUpNext = (idUpNext: string): StandardThunkAction => {
  return async (dispatch, getState) => {
    try {
      dispatch(dismissUpNextRequest());

      await API.client.rest.del(`members/me/upNext/${idUpNext}`);

      dispatch(dismissUpNextSuccess({ idUpNext }));
    } catch (err) {
      dispatch(dismissUpNextError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-up-next.ts